import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { PasswordResetService } from '../service/password-reset.service';

@Injectable()
export class PasswordResetGaurd implements CanActivate {
	constructor(
		private storageSessionService: StorageSessionService,
		private router: Router,
		private passwordResetService: PasswordResetService
	) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return new Promise((resolve) => {
			const details = next.params;
			this.passwordResetService.verifyChangePasswordDetails(details).subscribe((response: any) => {
				if (response.success) {
					resolve(true);
				} else {
					this.router.navigate(['/login']);
					resolve(false);
				}
			});
		});
	}
}
